import React from "react";

export const ExternalLink = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5708 7.52333V12.8093C12.5722 13.0107 12.5335 13.2102 12.4568 13.3964C12.3802 13.5826 12.2671 13.7516 12.1243 13.8935C11.9815 14.0354 11.8118 14.1474 11.6252 14.2229C11.4386 14.2985 11.2388 14.336 11.0375 14.3333H3.5328C3.33075 14.3359 3.13023 14.298 2.94306 14.2219C2.75589 14.1458 2.58586 14.0329 2.44301 13.89C2.30016 13.7471 2.18738 13.577 2.11131 13.3898C2.03525 13.2026 1.99745 13.002 2.00013 12.8V5.29533C1.99772 5.0933 2.03573 4.89283 2.11193 4.70571C2.18814 4.51858 2.30099 4.34859 2.44386 4.20572C2.58672 4.06286 2.75672 3.95 2.94384 3.8738C3.13096 3.7976 3.33144 3.75959 3.53347 3.762H8.8188M14.3328 2L7.28547 9.04733M14.3328 2H10.8088M14.3328 2V5.524"
        stroke="#262128"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
